/*
* 项目基础信息组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
} from 'antd';
import { PlusOutlined, ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    isGTscreenWidth,
    GetDropdownActionName,
    rootReactDom,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import BaseEntity from './BaseEntity';
import BaseInfo from './BaseInfo';
import WOMRSearch from '../wos/WOMRSearh';

const Option = Select.Option;
const MODULENAME = CNF.navItems[0].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[0].ptn;

const Lists = (props) => {
    const update = (record) => { props.setOpen(true, record); }

    const woMR = (record) => {
        rootReactDom && rootReactDom.render(
            <WOMRSearch
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                record={record}
            />);
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'project/bases/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case '月报':
                woMR(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, props.isRefresh, uri);
                break;
            default:
                break;
        }
    }

    /**
     * 显示项目基础信息
     * @param {*} record 
     */
    const showBaseInfo = (record) => {
        rootReactDom && rootReactDom.render(
            <BaseInfo
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                record={record}
            />);
    }

    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        {
            title: '项目名称', key: 'name', fixed: 'left',
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: 0, border: 0, height: 22 }}
                onClick={() => { showBaseInfo(record); }}>{record.name}</Button>
        },
        { title: '项目编号', dataIndex: 'number', key: 'number', fixed: 'left', },
        { title: '项目类型', dataIndex: 'type', key: 'type', },
        { title: '项目阶段', dataIndex: 'phase', key: 'phase', },
        {
            title: '项目等级', key: 'phase',
            render: (record) => CNF.projectRanks.find(item => item.value === record.rank).key
        },
        { title: '项目区域', dataIndex: 'area', key: 'area', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_wo_mr') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetDropdownActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            name: '',
            number: '',
            type: '',
            phase: '',
            rank: 0,
            status: CNF.status[0].value,
            area: '',
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeName = (e) => { this.setState({ name: e.target.value, }); this.search(); }
    changeNumber = (e) => { this.setState({ number: e.target.value, }); this.search(); }
    changeArea = (e) => { this.setState({ area: e.target.value, }); this.search(); }
    changeType = (value) => { this.setState({ type: value === undefined ? '' : value, }); this.search(); }
    changePhase = (value) => { this.setState({ phase: value === undefined ? '' : value, }); this.search(); }
    changeRank = (value) => { this.setState({ rank: value === undefined ? 0 : value, }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value === undefined ? '' : value, }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }


    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'name': this.state.name,
            'number': this.state.number,
            'phase': this.state.phase,
            'type': this.state.type,
            'area': this.state.area,
            'rank': this.state.rank,
            'status': this.state.status,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}project/bases${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
    * 导出 Excel
    */
    exportExecl = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目基础信息明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '项目编号',
                    '项目名称',
                    '项目类型',
                    '项目阶段',
                    '项目等级',
                    '项目区域',
                    '维护内容',
                    '备注',
                    '状态'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出项目基础信息明细
     */
    export() {
        const _this = this
        const params = {
            'name': this.state.name,
            'number': this.state.number,
            'phase': this.state.phase,
            'type': this.state.type,
            'area_ulid': this.state.areaULID,
            'status': this.state.status,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}project/bases${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['area_ulid'];
                            delete item['create_username']
                            delete item['create_displayname']
                            delete item['create_time']
                            delete item['update_time']
                            item['rank'] = CNF.projectRanks.find(item => item.value === data.dat[i].rank).key;
                            d.push(item);
                        }
                        _this.exportExecl(d);
                    } else {
                        _this.exportExecl([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeName}
                            placeholder='项目名称'
                            value={this.state.name}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 3 : 4} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeNumber}
                            placeholder='项目编码'
                            value={this.state.number}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='项目类型'
                            style={{ width: '100%' }}
                            onChange={this.changeType}
                        >
                            {
                                CNF.projectTypes.map((item, index) => {
                                    return <Option key={index} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='项目阶段'
                            style={{ width: '100%' }}
                            onChange={this.changePhase}
                        >
                            {
                                CNF.projectPhases.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeArea}
                            placeholder='项目区域'
                            value={this.state.area}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='项目等级'
                            style={{ width: '100%' }}
                            onChange={this.changeRank}
                        >
                            {
                                CNF.projectRanks.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                            options={CNF.status.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.label
                            }))}
                        />
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.export();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <BaseEntity
                        preGroup={this.props.preGroup}
                        btnLists={this.props.btnLists}
                        open={this.state.open}
                        record={this.state.record}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                        areaDDList={this.state.areaDDList}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            preGroup={this.props.preGroup}
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT